/**
 * @file 路由中语言处理-导航守卫
 */
// eslint-disable-next-line
// @ts-nocheck

// import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

import {
  supportLang,
  setAsyncLang,
  getLanguage,
  replacePath,
  getRouteLangPath
} from '@/lang/i18n';
import { lang } from '@/config/setup';

export default [
  ({ path, query, hash }: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext):void => {
    const pathLang = path.split('/')[1];
    let defaultLang = getLanguage();
    defaultLang = supportLang(defaultLang) ? defaultLang : lang;

    if (!import.meta.env.SSR) {
      const pathnameLang = window.location.pathname.split('/')[1];

      // 客户端环境兼容已废弃的 iso path，不然已废弃的 iso 语言标识链接会跳404
      if (supportLang(pathnameLang) && pathnameLang !== getRouteLangPath(pathnameLang) && path === '/404') {
        const compatiblePath = `${window.location.pathname}${window.location.search}`;
        window.location.href = `${window.location.origin}${compatiblePath.replace(pathnameLang, getRouteLangPath(pathnameLang))}`;
      }

      // 下线页面404跳转首页
      if (path === '/404' && ['zh-CN'].includes(pathnameLang)) {
        return next({
          path: replacePath('/', getRouteLangPath(pathnameLang)),
          query,
          hash,
          replace: false
        });
      }
    }

    // 特殊语言处理
    if (['ko-KR', 'zh-CN'].includes(pathLang)) {
      return next({
        path: replacePath(path, 'en-US'),
        query,
        hash,
        replace: false
      });
    } else if (!pathLang || !supportLang(pathLang)) {
      // 如果连接中没有语言或者语言不支持，需要重写path
      const routeLangPath = getRouteLangPath(defaultLang);

      return next({
        path: replacePath(path, routeLangPath),
        query,
        hash,
        replace: false
      });
    }

    // 设置语言
    setAsyncLang(pathLang || lang).then(() => next());
  }
];
